import { render, staticRenderFns } from "./StatisticsOverview.vue?vue&type=template&id=02b379ea&"
import script from "./StatisticsOverview.vue?vue&type=script&lang=js&"
export * from "./StatisticsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports